import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class SMS_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="sms_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>SMS Overview</h2>
              <p>
                The Nexoid framework includes the ability to send SMS or text
                messages to user’s mobiles. Text messages will appear on the
                user’s phone as “Nexoid”. Users cannot reply to a Nexoid text
                message.{" "}
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default SMS_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/SMS_overview.js